"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by pavel.arakelyan on 11/13/17.
 */
var CommunicationType;
(function (CommunicationType) {
    CommunicationType[CommunicationType["ROW_ELEMENT_SELECTED"] = 0] = "ROW_ELEMENT_SELECTED";
    CommunicationType[CommunicationType["COLUMN_ELEMENT_SELECTED"] = 1] = "COLUMN_ELEMENT_SELECTED";
    CommunicationType[CommunicationType["OPTIONS_PANEL_CHANGE"] = 2] = "OPTIONS_PANEL_CHANGE";
    CommunicationType[CommunicationType["ADDITIONAL_OPTIONS_CHANGE"] = 3] = "ADDITIONAL_OPTIONS_CHANGE";
    CommunicationType[CommunicationType["FILTER_CHANGE"] = 4] = "FILTER_CHANGE";
    CommunicationType[CommunicationType["FILTER_OPENED"] = 5] = "FILTER_OPENED";
    CommunicationType[CommunicationType["REPORT_STRUCTURE_CHANGE"] = 6] = "REPORT_STRUCTURE_CHANGE";
    CommunicationType[CommunicationType["REPORT_STRUCTURE_SETUP"] = 7] = "REPORT_STRUCTURE_SETUP";
    CommunicationType[CommunicationType["STYLE_CHANGE"] = 8] = "STYLE_CHANGE";
    CommunicationType[CommunicationType["COLUMNS_CHANGE"] = 9] = "COLUMNS_CHANGE";
})(CommunicationType = exports.CommunicationType || (exports.CommunicationType = {}));
//# sourceMappingURL=communication-action.js.map